import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Checkbox, Form, Modal, Select } from 'antd'
import { updateLocation } from '../../common/requests'
import css from './phone-numbers.css'

const { Option } = Select

class AddAndEditExternalOutboundNumberModal extends Component {
  constructor(props) {
    super(props)
    const { dso, locationId, locations } = props
    this.state = {
      error: null,
      selectedLocationIds: dso === false
        ? locations.map(loc => loc.id)
        : [locationId],
      selectedOutboundNumberId: props.outboundNumberId,
    }
  }

  handleCancel = () => {
    const { toggleEonModal } = this.props
    this.clearState()
    toggleEonModal(false, null)
  }

  handleConfirm = () => {
    const {
      practiceId,
      refetchLocations,
      saveContactInfo,
      toggleEonModal,
    } = this.props
    const {
      selectedLocationIds,
      selectedOutboundNumberId,
    } = this.state

    Promise.all(selectedLocationIds.map((locId) => {
      const data = {
        external_outbound_number_id: selectedOutboundNumberId || null,
      }
      return updateLocation(practiceId, locId, data)
    }))
      .then(() => {
        toggleEonModal(false, null)
        refetchLocations()
        selectedLocationIds.forEach((locId) => {
          saveContactInfo(locId, {
            outboundNumberId: selectedOutboundNumberId || null,
          })
        })
        this.clearState()
      })
      .catch(err => this.setState({ error: err.message }))
  }

  clearState = () => {
    const { dso, locationId, locations } = this.props
    this.setState({
      selectedLocationIds: dso === false
        ? locations.map(loc => loc.id)
        : [locationId],
      selectedOutboundNumberId: this.props.outboundNumberId,
    })
  }

  handleOutboundNumberChange = (selectedNumber) => {
    this.setState({
      selectedOutboundNumberId: selectedNumber,
    })
  }

  toggleLocation = ({ target: { checked, value: locationId } }) => {
    const { selectedLocationIds } = this.state
    if (checked) {
      this.setState({
        selectedLocationIds: [...selectedLocationIds, locationId],
      })
    } else {
      this.setState({
        selectedLocationIds: selectedLocationIds.filter(locId => locId !== locationId),
      })
    }
  }

  render() {
    const {
      error,
      selectedLocationIds,
      selectedOutboundNumberId,
    } = this.state
    const {
      dso,
      externalOutboundNumbers,
      locations,
      open,
    } = this.props
    const footerButtons = [
      <Button key="cancel" onClick={this.handleCancel}>
        Cancel
      </Button>,
      <Button
        key="confirm"
        type="primary"
        onClick={this.handleConfirm}
      >
        Confirm
      </Button>,
    ]

    const checked = locId => selectedLocationIds.includes(locId)

    return (
      <Modal
        title="Add/Edit Outbound Phone Numbers"
        visible={open}
        footer={footerButtons}
        onCancel={this.handleCancel}
      >
        <Form>
          <h4>Phone Number</h4>
          <Form.Item className={css.formItem}>
            <Select
              style={{ width: '230px' }}
              onChange={this.handleOutboundNumberChange}
              value={selectedOutboundNumberId || ''}
              name="outboundNumberId"
            >
              <Option value="">None</Option>
              {externalOutboundNumbers.map(number => (
                <Option value={number.id} key={number.id}>
                  {number.phone_number}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <h4>Locations</h4>
          {!dso && (
            <p style={{ marginBottom: '16px' }}>
              Note: All locations use the same Outbound Phone Number for non-DSO practices.
            </p>
          )}
          <Form.Item>
            <div className="ant-checkbox-modifier">
              <style>
                {`.ant-checkbox-modifier .ant-checkbox-wrapper {
                    margin-left: 0;
                    }`}
              </style>
              <div className={css.locationCheckboxes}>
                {!!locations &&
                  locations.map(({ id, name }) => (
                    <Checkbox
                      key={id}
                      checked={checked(id)}
                      name="location"
                      onChange={this.toggleLocation}
                      value={id}
                      disabled={!dso}
                    >
                      {name}
                    </Checkbox>
                  ))}
              </div>
            </div>
          </Form.Item>
          {!!error && <div className={css.errorText}>{error}</div>}
        </Form>
      </Modal>
    )
  }
}

AddAndEditExternalOutboundNumberModal.propTypes = {
  dso: PropTypes.bool.isRequired,
  externalOutboundNumbers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    phone_number: PropTypes.string.isRequired,
    active: PropTypes.bool,
    name: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    practice_id: PropTypes.number.isRequired,
  })).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  locationId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  outboundNumberId: PropTypes.string,
  practiceId: PropTypes.string.isRequired,
  refetchLocations: PropTypes.func.isRequired,
  toggleEonModal: PropTypes.func.isRequired,
  saveContactInfo: PropTypes.func.isRequired,
}

AddAndEditExternalOutboundNumberModal.defaultProps = {
  outboundNumberId: null
}

export default AddAndEditExternalOutboundNumberModal



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/AddAndEditExternalOutboundNumberModal.js